var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18",
    style: {
      enableBackground: "new 0 0 20 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B7B7B7",
    id: "Path_639",
    d: "M8.9,14.3l0.6-2.9C9.7,10.3,9,9.3,7.9,9C7.8,9,7.6,9,7.5,9H2V7.9L4.6,2h8.1C12.8,2,13,2.2,13,2.3v7.8 L8.9,14.3 M8,18l6.4-6.4c0.4-0.4,0.6-0.9,0.6-1.4V2.3C15,1,14,0,12.7,0H4.6C3.9,0,3.2,0.4,2.8,1L0.2,7.1C0.1,7.4,0,7.6,0,7.9V9 c0,1.1,0.9,2,2,2h5.5l-0.9,4.6c0,0.2,0,0.5,0.1,0.7c0.2,0.5,0.5,0.9,0.9,1.2L8,18z M18,11h2V0h-2c-0.6,0-1,0.4-1,1v9 C17,10.6,17.4,11,18,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownGray);
export default __webpack_public_path__ + "static/media/ThumbsDownGray.acf28eee8cfa397a782feb93e254820f.svg";
export { ForwardRef as ReactComponent };